import React from "react";
import { TableCell, TableRow } from "../../../design/table";
import moment from "moment";
import { Intake } from "../../../models/Intake";
import { Badge } from "../../../design/badge";
import IntakeStatusBadge from "../../../components/IntakeStatusBadge";
import { useUser } from "../../../contexts/UserContext";
import { MatterType } from "../../../models/MatterType";

interface Props {
  intake: Intake;
}

const IntakeListItem: React.FC<Props> = ({ intake }) => {
  const { users } = useUser();
  const client = users.find((client) => client._id === intake.createdBy);
  return (
    <TableRow href={`/intake/${intake._id}`}>
      <TableCell>{moment(intake.createdAt).format("lll")}</TableCell>
      <TableCell>
        {client?.firstName} {client?.lastName}
      </TableCell>
      <TableCell>{(intake.matterType as MatterType)?.name}</TableCell>
      <TableCell>
        <IntakeStatusBadge status={intake.status} />
      </TableCell>
      <TableCell>{intake.rating?.overallRating}</TableCell>
      <TableCell>
        <Badge color={intake.rating?.proceedWithMatter ? "green" : "red"}>
          {intake.rating?.proceedWithMatter ? "Yes" : "No"}
        </Badge>
      </TableCell>
    </TableRow>
  );
};

export default IntakeListItem;
